import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { IconButton } from '@mui/material';
import Bin from '../../../../Components/Icons/Bin';
import EditIcon from "../../../../Components/Icons/EditIcon";
import './VisitorTypes.scss'

class VisitorTypeListItem extends IbssComponent<IProps, IState>
{
    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
        };
    };

    public render(): JSX.Element
    {
        return (
            <div className={`list-visitor-types__list-item ${this.props.selected ? 'list-visitor-types__list-item--selected' : ''}`}>
                <div>{this.props.name}</div>
                <div>
                    <IconButton className='mr-2' onClick={() => this.props.onDelete(this.props.id)}><Bin /></IconButton>
                    <IconButton onClick={() => this.props.onEdit(this.props.id)}><EditIcon /></IconButton>
                </div>
            </div>
        )
    }
}

export default VisitorTypeListItem;

export interface IProps
{
    id: string;
    name: string;
    onDelete: (id: string) => void;
    onEdit: (id: string) => void;
    selected: boolean;
}

export interface IState
{
}